import { SegmentPageTemplate } from 'src/components/pages/segment/SegmentPageTemplate';

import { useRestoringForestsConfig } from './RestoringForestsConfig';

export const RestoringForestsPage = () => {
  const { isBundleLoading, config } = useRestoringForestsConfig();

  return (
    <SegmentPageTemplate config={config} isBundleLoading={isBundleLoading} breadcrumbTitle={config?.heroAsset?.title} />
  );
};
